import { domReady } from './utils.js';

async function init() {
  await domReady();

  const isMoonRoutinePage = document.querySelector('.layout--pagemoon-routine');
  if (!isMoonRoutinePage) return;


}

init();
